import { axiosPrivate } from './common/axiosPrivate';
import { getQueryParams, handleResponse, handleError } from '../../helpers/network';

export const list = async ({ filter = '', role = '', page = 1, size = 10 }) => {
    const params = getQueryParams({ filter, role, page, size });
    return axiosPrivate.get(`/users?${params}`).then(handleResponse).catch(handleError);
};

export const get = async (id) => {
    return axiosPrivate.get(`/users/${id}`).then(handleResponse).catch(handleError);
};

export const create = async (item) => {
    return axiosPrivate.post(`/users`, item).then(handleResponse).catch(handleError);
};

export const update = async (item) => {
    return axiosPrivate.put(`/users/${item.id}`, item).then(handleResponse).catch(handleError);
};

export const remove = async (id) => {
    return axiosPrivate.delete(`/users/${id}`).then(handleResponse).catch(handleError);
};
